import React, { Component } from 'react';
import Sidebar from './../sidebar'
import Headers from './../headers'

class Staffs extends Component {
    state = {  }
    render() { 
        return ( 
            <div className='row m-0 p-0 bg-clr'>
                <div className='col-2'>
                <Sidebar/>
                </div>
                <div className='col-10'>
                <Headers/>
                ini halaman Staffs
                </div>
            </div>
         );
    }
}
 
export default Staffs;